import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const RewindButton = ({ shouldDisplayRewindButton, translate, rewindButtonHandler, spinnerToggle }) => {
  const theme = useTheme();
  if (!shouldDisplayRewindButton) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + "/images/playback-skip-back.svg"}
      alt={translate("rewind")}
      buttonClassName="playbackButton"
      onClickHandler={rewindButtonHandler}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default RewindButton;
